import { render } from "./PositionControl.vue?vue&type=template&id=f474f458&scoped=true&ts=true"
import script from "./PositionControl.vue?vue&type=script&lang=ts"
export * from "./PositionControl.vue?vue&type=script&lang=ts"

import "./PositionControl.vue?vue&type=style&index=0&id=f474f458&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f474f458"]])

export default __exports__